export const translations = {
  en: {
    emergencyContacts: {
      addEmergencyContact: 'Add emergency contact',
      addAsNewContact: 'Yes, add as new contact',
      editEmergencyContact: 'Edit emergency contact',
      emergencyContactUpdateContent:
        'We noticed multiple fields change for this emergency contact. Should we add them as a new contact?',
      newEmergencyContactTitle: 'Is this contact new?',
      noEmergencyContacts: 'No emergency contacts',
      phoneType: 'Phone Type',
      removeEmergencyContact: 'Remove emergency contact',
      removeEmergencyContactConfirmation:
        'Please confirm the removal of your emergency contact to continue.',
      updateExistingContact: 'Update existing contact',
      emergencyContactModalInvalidFieldError:
        'Please enter a valid {{fieldName}}.',
      emergencyContactModalRequiredFieldError: '{{fieldName}} is required.',
    },
  },
  es: {
    emergencyContacts: {
      addEmergencyContact: 'Agregar contacto de emergencia',
      addAsNewContact: 'Sí, agregar como nuevo contacto',
      editEmergencyContact: 'Editar contacto de emergencia',
      emergencyContactUpdateContent:
        'Notamos cambios en varios campos para este contacto de emergencia. ¿Deberíamos agregarlos como un nuevo contacto?',
      newEmergencyContactTitle: '¿Es este contacto nuevo?',
      noEmergencyContacts: 'Sin contactos de emergencia',
      phoneType: 'Tipo de teléfono',
      removeEmergencyContact: 'Eliminar contacto de emergencia',
      removeEmergencyContactConfirmation:
        'Por favor, confirma la eliminación de tu contacto de emergencia para continuar.',
      updateExistingContact: 'Actualizar contacto existente',
      emergencyContactModalInvalidFieldError:
        'Por favor, ingresa un {{fieldName}} válido.',
      emergencyContactModalRequiredFieldError: '{{fieldName}} es obligatorio.',
    },
  },
};
